import React, { Component } from 'react';


import TyroModalLoader from './TyroModalLoader';
import TyroModalButtonGroup from './TyroModalButtonGroup';


export default class TyroModalMessage extends Component {
  render() {
    const { message = "" } = this.props;
    return (
      <div>
        <div className="ui center aligned basic segment paddingless marginless">
          <TyroModalLoader />
          <h2 className="ui small header" style={{ margin: 0 }}>{message.toUpperCase()}</h2>
        </div>
        <div className="ui basic clearing segment paddingless">
          <TyroModalButtonGroup />
        </div>
      </div>
    );
  }
}